import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
const appliesToItem = ({ appliesTo = 'all' }, file) => appliesTo === 'all' || appliesTo === (file.data.isFolder ? 'folder' : 'file');
/** The actions from `actions` that apply to this item (file vs folder). */
export function getApplicableActions(actions, file) {
    return actions.filter((action) => appliesToItem(action, file));
}
/**
 * The "⋯" trigger for an item's actions menu (rename, delete, copy URL, …).
 * The menu itself is rendered by `Browser` (see ItemActionsPopover) so that it
 * is not clipped by the scrolling list and only one can be open at a time.
 */
export default function ItemActionsMenu({ file, actions, open, onToggle, i18n, }) {
    if (!actions.some((action) => appliesToItem(action, file)))
        return null;
    return (_jsx("div", { className: "uppy-ProviderBrowserItem-actions", children: _jsx("button", { type: "button", className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-actionsBtn", "aria-label": i18n('itemActionsNamed', {
                name: file.data.name ?? i18n('unnamed'),
            }), "aria-haspopup": "menu", "aria-expanded": open, onClick: (event) => {
                event.stopPropagation();
                event.preventDefault();
                onToggle(event.currentTarget);
            }, children: _jsxs("svg", { "aria-hidden": "true", width: "16", height: "16", viewBox: "0 0 16 16", focusable: "false", children: [_jsx("circle", { cx: "3", cy: "8", r: "1.5", fill: "currentColor" }), _jsx("circle", { cx: "8", cy: "8", r: "1.5", fill: "currentColor" }), _jsx("circle", { cx: "13", cy: "8", r: "1.5", fill: "currentColor" })] }) }) }));
}
